import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';

const StyledNote = styled.div`
    padding: 0.8rem;
    border-left: ${({ theme }) => `3px solid ${theme.infoMain}`};
    background-color: ${({ theme }) => `${theme.infoLightest}`};
    margin-top: 1rem;
    margin-bottom: 1rem;
`;

interface NoteProps {
    message: string;
    isNoteLabelVisible?: boolean;
}

const Note: React.FC<NoteProps> = ({ message, isNoteLabelVisible = true }) => {
    return (
        <StyledNote>
            <ConditionalRendering isTrue={isNoteLabelVisible}>
                <strong>
                    <FormattedMessage id={'member.enrollment_list.premiumhistory.boldNote'} tagName={'span'} />{' '}
                </strong>
            </ConditionalRendering>
            <FormattedMessage id={message} tagName={'span'} />
        </StyledNote>
    );
};

export default Note;
